import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { deleteCepIntegration } from '../api'

const useDeleteCepIntegration = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (integrationId: string) =>
      deleteCepIntegration({ accountId, integrationId }),
    onSuccess: () => {
      successToast('Integration has been successfully deleted')
      queryClient.invalidateQueries({
        queryKey: cepIntegrationsKeys.listAccountCepIntegrations(accountId),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useDeleteCepIntegration
